import script from "./my_profile.vue?vue&type=script&setup=true&lang=ts"
export * from "./my_profile.vue?vue&type=script&setup=true&lang=ts"

import "./my_profile.vue?vue&type=style&index=0&id=54d949a7&lang=scss&scoped=true"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d949a7"]])

export default __exports__